import GLightbox from 'glightbox'

export default {
  init() {
    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
